"use strict";
async function fetchWithRetry({ url, numberOfRetries = 3, options = {} }) {
  const retriesLeft = numberOfRetries - 1;
  if (retriesLeft == 0) return Promise.reject("Too many attempts without luck");

  return await fetch(url, options).catch(async (error) => {
    if (numberOfRetries !== 0) {
      await fetchWithRetry({
        url,
        numberOfRetries: retriesLeft,
      });
    }
    return error;
  });
}

function localTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

async function getUserLocation() {
  const API = "https://api.ipgeolocation.io/ipgeo?apiKey=" + mutant.config.geo;
  const result = await fetchWithRetry({ url: API, numberOfRetries: 5 });
  return result.json();
}

function getLocalStorage(key) {
  const local = window.localStorage.getItem(key);
  if (!local) {
    return false;
  }
  return JSON.parse(local);
}

function setLocalStorage(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return { ...value };
  } catch {
    return false;
  }
}

function isExpired(date, minutes) {
  const MIN = minutes * 60 * 1000;
  if (new Date() - new Date(date) < MIN) {
    return false;
  }
  return true;
}

const locationObj = (item) => {
  return {
    redirect: item.truly,
    redirect_to: item.domain,
  };
};

async function getValidateLocation(userLocation) {
  // check if the location is correspondent to the website
  const url = window.location.hostname;

  if (url.includes(".ca")) {
    return userLocation !== "CA"
      ? locationObj({ truly: true, domain: "iammutant.com" })
      : locationObj({ truly: false, domain: "iammutant.ca" });
  }

  if (!url.includes(".ca")) {
    return userLocation !== "CA"
      ? locationObj({ truly: false, domain: "iammutant.com" })
      : locationObj({ truly: true, domain: "iammutant.ca" });
  }
}

/*
 * Initialize Modal
 */

function redirectButton(url) {
  let link = document.querySelector(".popup-cta a.btn");
  link.href = "https://" + url;
  const flagSpan = document.querySelector("span.reditect-flag");
  url === "iammutant.ca"
    ? (flagSpan.innerHTML += "🇨🇦")
    : (flagSpan.innerHTML += "🇺🇸");
}

mutant.RedirectModal = (() => {
  function RedirectPopup(container, url) {
    if (!container) {
      return;
    }

    const sectionId = container.getAttribute("data-section-id");

    const modal = new theme.Modals(
      "RedirectPopup-" + sectionId,
      "redirect-popup-modal"
    );

    redirectButton(url);

    modal.open();
  }
  return RedirectPopup;
})();

const queryModal = () => {
  const type = "redirect-popup";
  return document.querySelector('[data-section-type="' + type + '"]');
};

async function initPopUpLocation({ key, container }) {
  if (!container) return;

  const config = {
    local: getLocalStorage(key),
    minutes: container.dataset.sectionInterval,
    mode: container.dataset.testMode,
  };

  if (!config.local) {
    try {
      const { country_code2 } = await getUserLocation();
      const url = await getValidateLocation(country_code2);
      if (url.redirect) {
        new mutant.RedirectModal(container, url.redirect_to);
      }
      return setLocalStorage(key, {
        country: country_code2,
        created_at: new Date().getTime(),
      });
    } catch (error) {
      console.error("LocalStorage Error: ", error);
    }
    //  TODO: find user time zone in case some of the process fails
    const local = localTimeZone();
    return;
  }

  let expired = isExpired(config.local.created_at, config.minutes || 10);
  if (expired) {
    try {
      const { country_code2 } = await getUserLocation();
      const url = await getValidateLocation(country_code2);

      if (url.redirect) {
        const redirectModal = new mutant.RedirectModal(
          container,
          url.redirect_to
        );
      }

      setLocalStorage(key, {
        country: country_code2,
        created_at: new Date().getTime(),
      });
    } catch (error) {
      console.error("Expired Popup Error: ", error);
    }
  }
}

/*
 * PROP65
 */

mutant.prop65 = (() => {
  function warning(container) {
    if (!container) {
      return;
    }

    if (!!container.getAttribute("data-warning")) {
      container.setAttribute("data-warning", "true");
    }
  }
  return warning;
})();

async function initProp65(container) {
  const key = "MUTANT-PROP65";
  const local = getLocalStorage(key);
  let expired = isExpired(local.created_at, 0.25);

  if (expired) {
    try {
      const { state_prov, country_code2 } = await getUserLocation();
      const data = await mutData(state_prov, country_code2);

      setLocalStorage("MUTANT-PROP65", {
        ...data,
        created_at: new Date().getTime(),
      });
      if (data.state_prov === "California") {
        new mutant.prop65(container);
      }
    } catch (error) {
      console.error("PROP65 Expired Error: ", error);
      new mutant.prop65(container);
    }
  }
  if (local.state_prov === "California") {
    new mutant.prop65(container);
  }
}

function hasDataTag(dataTag) {
  const hastag = document.querySelector(dataTag);
  if (!hastag) {
    return null;
  }
  return hastag;
}

async function mutData(state_prov, country) {
  const data = {
    state_prov,
    country,
    created_at: new Date().getTime(),
  };

  return data;
}

const queryButton = () => {
  return document.querySelector("[data-add-to-cart]");
};

(async function () {
  const config = {
    key: "MUTANT-LOCAL",
    hasPropTag: hasDataTag("[data-block-id=prop65-warning]"),
    localStorage: getLocalStorage("MUTANT-LOCAL"),
    minutes: 5,
  };

  if (config.hasPropTag) {
    initProp65(config.hasPropTag);
  }
})();

initPopUpLocation({
  key: "MUTANT-REDIRECT",
  container: queryModal(),
});

/*
 * FORMAT MONEY
 */

function formatMoney(amount = 0) {
  const options = {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  };

  if (amount % 100 === 0) {
    options.minimumFractionDigits = 0;
  }

  const formatter = Intl.NumberFormat("en-US", options);

  return formatter.format(amount / 100);
}
